import { Component, OnInit, Inject, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatDialog, getMatFormFieldDuplicatedHintError } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service';
import { ServerService } from '../../../services/server.service';
import { DatePipe } from '@angular/common';
import { CreatePresalesJobComponent } from '../create-presales-job/create-presales-job.component'; 
import { ClipBoardService as messageService} from 'src/app/services/clipboard.service';

@Component({
  selector: 'app-create-presales-progress-log',
  templateUrl: './create-presales-progress-log.component.html',
  styleUrls: ['./create-presales-progress-log.component.scss']
})
export class CreatePresalesProgressLogComponent implements OnInit {

  authToken = localStorage.getItem("token");

  showComponentLoader: boolean = false;

  btnStatus: boolean = false

  myDateRangePickerOptions = {
    dateFormat: 'dd.mm.yyyy'
  };

  addForm: FormGroup;

  headerStats: any;

  currentDate: any = new Date();

  campaignData:any;

  clientFeedbackTobeUpload:any;
  analysisTobeUpload:any;

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<CreatePresalesJobComponent>,
    private clipBoardMessageService:messageService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    this.campaignData = data
  }

  ngOnInit() {
    this.setDeliveryForm()
    this.getPreSalesLogListStats()
  }

  getPreSalesLogListStats() {

    this.showComponentLoader = true;

    //let url = "campaign_module/campaign/spent_budget_delivery_stats/"+this.data.id;
    let url = "campaign_module/pre_sales_jobs/pre_sales_progress_log/stats?campaign_id=" + this.data.campaign_id+ '&pre_sales_job_id='+ this.data.id;
    // campaign_module/pre_sales_jobs/pre_sales_progress_log/stats?campaign_id=152&pre_sales_job_id=64
    this.serverService.getSpentBudgetDeliveryStats(url, this.authToken).subscribe(data => {
      //console.log(data)
      this.headerStats = data.stats[0]
      //console.log(this.headerStats)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }


  selectFile(event: any, uploadSectionType: any): any {

    if (!event.target.files.length) {
        return false
    }

    //console.log(event.target.files)

    if (uploadSectionType == 'clientFeedbackSheet') {
        this.clientFeedbackTobeUpload = event.target.files[0];
    }

    if (uploadSectionType == 'analysisSheet') {
      this.analysisTobeUpload = event.target.files[0];
    }

    // console.log(this.clientFeedbackTobeUpload)
    // console.log(this.analysisTobeUpload)

}


  // setDeliveryForm() {
  //   this.addForm = this.fb.group({
  //     analysis_at: ['', Validators.compose([Validators.required])],
  //     leads_delivered: ['', Validators.compose([Validators.required])],
  //     feedback_received: ['', Validators.compose([Validators.required])],
  //     leads_qualified: [null, Validators.compose([Validators.required])],
  //     leads_qualified_out_of_tat: [null, Validators.compose([Validators.required])],
  //     client_feedback_sheet: [null, Validators.compose([Validators.required])],
  //     analysis_sheet: [null, Validators.compose([Validators.required])]
  //   })
  // }

  saveDeliveryForm() {

    this.btnStatus = true;

    let body = {
      campaign_id: this.data.campaign_id,
      pre_sales_job_id: this.data.id,
      records: this.addForm.value.addInnerForm
    }

    this.serverService.saveDeliveryForm('campaign_module/pre_sales_jobs/pre_sales_progress_log/create', body, this.authToken).subscribe(data => {
      this.clipBoardMessageService.showMessgeInText("Presales Progress log Added Successfully", "success-snackbar")
      this.btnStatus = false
      this.dialogRef.close(data)
    },
      err => {
        this.btnStatus = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  close() {
    this.dialogRef.close();
  }

  onKeyPress(event: KeyboardEvent) {
    const allowedCharacters = /[0-9\+]/;
    const inputChar = String.fromCharCode(event.keyCode);

    if (!allowedCharacters.test(inputChar)) {
      event.preventDefault();
    }
  }

  setDeliveryForm() {
    this.addForm = this.fb.group({
      addInnerForm: this.fb.array([this.setAddDeliveryForm()])
    })
  }

  setAddDeliveryForm() {
    return this.fb.group({
      recorded_date: ['', Validators.compose([Validators.required])],
      calls: ['', Validators.compose([Validators.required])],
      verified: [, Validators.compose([Validators.required])],
      site_visit: [[], Validators.compose([Validators.required])],
      callbacks: ['',Validators.compose([Validators.required])],
      not_responding: [null, Validators.compose([Validators.required])],
      not_interested: [[], Validators.compose([Validators.required])],
    })
  }
  get arrAddDeliveryForm(): FormArray {
    return this.addForm.get("addInnerForm") as FormArray;
  }

  addRow() {
    this.arrAddDeliveryForm.push(this.setAddDeliveryForm());
    // this.initConditionalValidation();
  }

  removeRow(i) {
    if (this.arrAddDeliveryForm.length > 1) {
      this.arrAddDeliveryForm.removeAt(i);
    }
  }
}
